export interface RuntimeConfig {
  schemaVersion: 'web-runtime-config/1';
  apiBase: string;
}

export function normalizeApiBase(value: unknown): string {
  if (typeof value !== 'string' || !value.trim()) throw new Error('apiBase必须是非空地址');
  const raw = value.trim();
  if (raw.includes('\\') || (!raw.startsWith('/') && !/^https?:\/\//i.test(raw)) || raw.startsWith('//'))
    throw new Error('apiBase必须是绝对HTTP(S)地址或以/开头的同源路径');
  let url: URL;
  try { url = new URL(raw, 'http://runtime-config.invalid'); }
  catch { throw new Error('apiBase不是有效地址'); }
  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || url.search || url.hash)
    throw new Error('apiBase不能包含凭据、查询参数或片段');
  if (url.pathname === '/') throw new Error('apiBase必须包含API路径');
  const pathname = url.pathname.replace(/\/+$/, '');
  return raw.startsWith('/') ? pathname : url.origin + pathname;
}

let config: RuntimeConfig = {
  schemaVersion: 'web-runtime-config/1',
  apiBase: normalizeApiBase(import.meta.env.VITE_API_BASE || '/api'),
};

export function getApiBase(): string { return config.apiBase; }

/** Load before importing the application, so axios, downloads and route guards share one base. */
export async function loadRuntimeConfig(): Promise<void> {
  const response = await fetch(`${import.meta.env.BASE_URL}runtime-config.json`, {
    cache: 'no-store', credentials: 'same-origin', signal: AbortSignal.timeout(10000),
  });
  if (!response.ok) throw new Error('运行配置加载失败');
  const raw: unknown = await response.json();
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) throw new Error('运行配置格式错误');
  const value = raw as Record<string, unknown>;
  if (value.schemaVersion !== 'web-runtime-config/1' || Object.keys(value).some(k => !['schemaVersion', 'apiBase'].includes(k)))
    throw new Error('运行配置版本或字段错误');
  config = {
    schemaVersion: 'web-runtime-config/1',
    apiBase: value.apiBase === undefined ? config.apiBase : normalizeApiBase(value.apiBase),
  };
}
